// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"182":"8917d6ec90f9ee2bf6b2","600":"589e82e5d608284fcb16"}[chunkId] + ".bundle.js";
};